import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

import withModal from '../../../commons/hocModal';

import { translate } from '../../../commons/localize';
import { orderObjectsListAlphabetically } from '../../../commons/utils';

import SelectorHotel from '../../../commonComponents/SelectorHotel';
import SelectorDropDown from '../../../commonComponents/SelectorDropDown';
import SelectorInput from '../../../commonComponents/SelectorInput';
import ButtonCustom from '../../../commonComponents/ButtonCustom';

import { searchFormPropTypes, searchFormDefaultProps } from './propTypes';
import { mapStateToProps, mapDispatchToProps } from './reducerConsts';

const SearchForm = (props) => {
  const {
    userDefaultHotel,
    hotelCode,
    hotelsList,
    operatorCode,
    operatorsList,
    locatorTTOO,
    lockSearchForm,
    setHotelFilter,
    setOperatorFilter,
    setLocatorFilter,
    getTourOperatorsList,
    getRoomsListByTourOperator,
    getContractsList,
    getReservationsList,
    getHotelGroups,
    handleSearchAction,
    handleModalMessages
  } = props;

  useEffect(() => {
    if (hotelCode === '') return;

    if (!hotelsList || hotelsList.length === 0) return;

    getTourOperatorsByHotel(hotelCode);
    getGroupsByHotel(hotelCode);
  }, [props.hotelCode]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (operatorCode === '') return;

    getHotelRoomsListByTourOperator(hotelCode, operatorCode);
  }, [props.operatorCode]); // eslint-disable-line react-hooks/exhaustive-deps

  function itsInvalidForm() {
    if (lockSearchForm) return true;

    if (hotelCode === '') return true;

    if (operatorCode === '') return true;

    if (locatorTTOO === '') return true;

    return false;
  }

  function getHotelRoomsListByTourOperator(hotelCode, operatorCode) {
    getRoomsListByTourOperator(
      hotelCode,
      operatorCode,
      (errorMessage) => {
        handleModalMessages('errorModal', 'errorConsultarRoomDis', errorMessage, 'entendido');
      },
      () => {
        getContractsByTourOperator(operatorCode);
      }
    );
  }

  function getTourOperatorsByHotel(hotelCode) {
    getTourOperatorsList(
      hotelCode,
      (errorMessage) => {
        handleModalMessages('errorModal', 'errorConsultarTTOO', errorMessage, 'entendido');
      },
      (numberOfOperators, operatorCode) => {
        switch (numberOfOperators) {
          case 0: {
            handleModalMessages('atencionModal', 'noExistenTTOO', undefined, 'entendido');
            break;
          }
          case 1: {
            if (operatorCode) setOperatorFilter(operatorCode);
            break;
          }
          default:
            break;
        }
      }
    )
  }

  function getGroupsByHotel(hotelCode) {
    getHotelGroups(
      hotelCode,
      (errorMessage) => {
        handleModalMessages('errorModal', 'errorConsultarGrupos', errorMessage, 'entendido');
      }
    );
  }

  function getContractsByTourOperator(operatorCode) {
    getContractsList(
      hotelCode,
      operatorCode,
      (errorMessage) => {
        handleModalMessages('errorModal', 'errorConsultarContratos', errorMessage, 'entendido');
      },
      () => {
        handleModalMessages('atencionModal', 'noExistenContratos', undefined, 'entendido');
      }
    );
  }

  function setSearchFilterHotel(hotelCode) {
    setHotelFilter(hotelCode);
    handleSearchAction(false);
  }

  function setSearchFilterTourOperator(operatorCode) {
    setOperatorFilter(operatorCode.toString());
    handleSearchAction(false);
  }

  function setSearchFilterLocatorTTOO(locatorCode) {
    setLocatorFilter(locatorCode);
    handleSearchAction(false);
  }

  function searchReservations() {
    getReservationsList(
      hotelCode,
      operatorCode,
      locatorTTOO,
      (errorMessage) => {
        handleModalMessages('errorModal', 'errorListadoReservas', errorMessage, 'entendido');
        handleSearchAction(false);
      },
      () => {
        handleSearchAction(true);
      }
    );
  }

  function invalidFormMessages() {
    if (lockSearchForm) {
      showUnsavedChangesMessage();
      return;
    }

    if (itsInvalidForm()) handleModalMessages('atencionModal', 'faltanDatosFormulario', undefined, 'entendido')
  }

  function showUnsavedChangesMessage() {
    handleModalMessages('atencionModal', 'cambiosExistentes', undefined, 'entendido');
  }

  return (
    <Row className="auto-margin search-form__container">
      <Col sm="4" className="no-padding-left">
        <SelectorHotel
          title={translate('seleccionHotel')}
          dataTestLabel="selector-hotel"
          placeHolder={translate('placeHolderSelector')}
          options={hotelsList}
          userDefaultHotel={userDefaultHotel}
          defaultValue={hotelCode}
          stopPropagation={lockSearchForm}
          dirtyEvent={showUnsavedChangesMessage}
          handleSelectOption={setSearchFilterHotel}
        />
      </Col>
      <Col sm="4" className="no-padding-left">
        <SelectorDropDown
          title={translate('seleccionTourOperador')}
          dataTestLabel="selector-touroperador"
          placeHolder={translate('placeHolderSelector')}
          options={orderObjectsListAlphabetically(operatorsList, 'label')}
          defaultValue={operatorCode}
          checkPrevProps
          stopPropagation={lockSearchForm}
          dirtyEvent={showUnsavedChangesMessage}
          handleSelectOption={setSearchFilterTourOperator}
        />
      </Col>
      <Col sm="3" className="no-padding-left">
        <SelectorInput
          title={translate('localizadorExterno')}
          dataTestLabel="localizador-externo"
          name="localizador-externo"
          placeHolder={translate('introduirLocalizador')}
          defaultValue={locatorTTOO}
          preventChangeValue={lockSearchForm}
          dirtyEvent={showUnsavedChangesMessage}
          onChangeEvent={setSearchFilterLocatorTTOO}
        />
      </Col>
      <Col sm="1" className="align-self-end no-padding-right search-bttn__container" onClick={invalidFormMessages}>
        <ButtonCustom
          label={translate('buscar')}
          colorClass="search-bttn"
          dataTestLabel="boton-buscar"
          clickAction={searchReservations}
          isDisabled={itsInvalidForm()}
        />
      </Col>
    </Row>
  );
};

SearchForm.propTypes = searchFormPropTypes;

SearchForm.defaultProps = searchFormDefaultProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withModal(SearchForm));
export { SearchForm };
